const CONFIGURACION_INTEGRACIONES_FULL_HARDCODED_YPF = {
  habilitarFacturacionArticulosFullPlaya: true,
};
const getConfiguracionIntegracionesFULL = async () => {
  return CONFIGURACION_INTEGRACIONES_FULL_HARDCODED_YPF;
};

const configuracionIntegracionesFULL = {
  getConfiguracionIntegracionesFULL,
};

export default configuracionIntegracionesFULL;
